import { useCallback, useState } from 'react';

import { useUniqueNativeID } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const useProductDetailsTabs = (params: Params) => {
  const { hasIngredientHighlights } = params;

  const initialTab = hasIngredientHighlights ? TABS.INGREDIENT_HIGHLIGHTS : TABS.NUTRITION; // prettier-ignore

  // ─── State ───────────────────────────────────────────────────────────

  const [activeTabId, setActiveTabId] = useState(initialTab);

  // ─── Helpers ─────────────────────────────────────────────────────────

  const setActiveTabToIngredientHighlights = useCallback(() => {
    setActiveTabId(TABS.INGREDIENT_HIGHLIGHTS);
  }, []);

  const setActiveTabToNutrition = useCallback(() => {
    setActiveTabId(TABS.NUTRITION);
  }, []);

  // ─────────────────────────────────────────────────────────────────────

  const isIngredientHighlightsTabActive = activeTabId === TABS.INGREDIENT_HIGHLIGHTS;
  const isNutritionTabActive = activeTabId === TABS.NUTRITION;
  const ingredientHighlightsNativeId = useUniqueNativeID(TABS.INGREDIENT_HIGHLIGHTS); // prettier-ignore
  const ingredientHighlightsPanelNativeId = useUniqueNativeID(`${TABS.INGREDIENT_HIGHLIGHTS}_PANEL`); // prettier-ignore
  const nutritionNativeId = useUniqueNativeID(TABS.NUTRITION);
  const nutritionPanelNativeId = useUniqueNativeID(`${TABS.NUTRITION}_PANEL`);

  // ─────────────────────────────────────────────────────────────────────

  return {
    isIngredientHighlightsTabActive,
    isNutritionTabActive,
    ingredientHighlightsNativeId,
    ingredientHighlightsPanelNativeId,
    nutritionNativeId,
    nutritionPanelNativeId,
    setActiveTabToIngredientHighlights,
    setActiveTabToNutrition,
  };
};

// ─── Constants ───────────────────────────────────────────────────────────────

const TABS = {
  INGREDIENT_HIGHLIGHTS: 'ingredient-highlights',
  NUTRITION: 'nutrition',
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  hasIngredientHighlights: boolean;
};
